import { useEffect, useRef, useState } from 'preact/hooks';
import type { SupabaseClient } from '@supabase/supabase-js';
import { mensajeError, soloDigitos } from './acceso';

// Primera vez: se configura la app de códigos escaneando un QR (o escribiendo la clave) y se confirma con un código.
export function Inscribir({ sb, onListo }: { sb: SupabaseClient; onListo: () => void }) {
  const [factor, setFactor] = useState<{ id: string; qr: string; clave: string } | null>(null);
  const [codigo, setCodigo] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const iniciado = useRef(false);
  useEffect(() => {
    if (iniciado.current) return;
    iniciado.current = true;
    (async () => {
      // Si quedó una configuración a medias de un intento anterior, se borra y se empieza de nuevo.
      const { data: lista } = await sb.auth.mfa.listFactors();
      for (const f of lista?.all || []) if (f.factor_type === 'totp' && f.status !== 'verified') await sb.auth.mfa.unenroll({ factorId: f.id });
      const { data, error } = await sb.auth.mfa.enroll({ factorType: 'totp', friendlyName: 'Talentino', issuer: 'Talentino' });
      if (error || !data) { setError(mensajeError(error)); return; }
      setFactor({ id: data.id, qr: data.totp.qr_code, clave: data.totp.secret });
    })();
  }, []);
  const confirmar = async (e: Event) => {
    e.preventDefault();
    setError('');
    if (!factor) return;
    if (codigo.length !== 6) { setError('El código tiene 6 números.'); return; }
    setEnviando(true);
    const { error } = await sb.auth.mfa.challengeAndVerify({ factorId: factor.id, code: codigo });
    setEnviando(false);
    if (error) { setError(mensajeError(error)); setCodigo(''); return; }
    onListo();
  };
  return (
    <form class="panel form" onSubmit={confirmar} aria-label="Configurar el código de verificación">
      <h2>Configura tu código de verificación</h2>
      <p>Se hace una sola vez. Desde ahora, además de la contraseña, el sistema te pedirá un número de 6 dígitos que cambia cada 30 segundos.</p>
      <ol class="pasos">
        <li>En tu app de códigos (1Password, Contraseñas de Apple o Google Authenticator) agrega una cuenta o código nuevo.</li>
        <li>Escanea este QR. Si no puedes escanearlo, escribe la clave que aparece debajo.</li>
        <li>Escribe aquí el número de 6 dígitos que muestra la app.</li>
      </ol>
      {factor ? (
        <div class="qr">
          <img src={factor.qr} alt="Código QR para configurar la app de códigos" width={200} height={200} />
          <p class="hint">Clave: <code>{factor.clave.replace(/(.{4})/g, '$1 ').trim()}</code></p>
        </div>
      ) : !error && <p class="hint">Preparando el código…</p>}
      <label for="codigo">Código de 6 números</label>
      <input id="codigo" class="in codigo" inputMode="numeric" autocomplete="one-time-code" maxLength={6} value={codigo} onInput={e => setCodigo(soloDigitos(e.currentTarget.value))} />
      {error && <p class="error" role="alert">{error}</p>}
      <button class="btn primary" type="submit" disabled={enviando || !factor}>{enviando ? 'Confirmando…' : 'Confirmar'}</button>
      <button class="btn link" type="button" onClick={() => sb.auth.signOut()}>Salir</button>
    </form>
  );
}
